import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.root}>
      <p>© 2023 FraudCue. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
